import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {AgentViewWorkspaceCapabilityUdoTemplateKey} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/agentViewWorkspaceCapability/domain/AgentViewWorkspaceCapabilityUdoTemplateKey";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type AgentViewWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.agentView> & {
    fixedUdoTemplates: {
        [AgentViewWorkspaceCapabilityUdoTemplateKey.capacity]: {
            udoAdditionalColumnIds: {
                capacity: Uuid;
                userId: Uuid;
            };
        };
        [AgentViewWorkspaceCapabilityUdoTemplateKey.dayPlanItem]: {
            udoAdditionalColumnIds: {
                agentUserId: Uuid;
                assignedOn: Uuid;
                completedAt: Uuid;
                completedDisposition: Uuid;
                disposition: Uuid;
                eventContainerId: Uuid;
                itemStatus: Uuid;
                leadCategory: Uuid;
                planDate: Uuid;
                queueMode: Uuid;
                queueReason: Uuid;
                scheduledOn: Uuid;
                slaBreachedAt: Uuid;
                sourcePriority: Uuid;
            };
        };
        [AgentViewWorkspaceCapabilityUdoTemplateKey.dayPlanRun]: {
            udoAdditionalColumnIds: {
                completedAt: Uuid;
                planDate: Uuid;
            };
        };
    };
};

export const agentViewWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [AgentViewWorkspaceCapabilityUdoTemplateKey.capacity]: zod.strictObject({
            udoTemplateId: uuidZodValidator,
            udoAdditionalColumnIds: zod.strictObject({
                capacity: uuidZodValidator,
                userId: uuidZodValidator,
            }),
        }),
        [AgentViewWorkspaceCapabilityUdoTemplateKey.dayPlanItem]: zod.strictObject({
            udoTemplateId: uuidZodValidator,
            udoAdditionalColumnIds: zod.strictObject({
                agentUserId: uuidZodValidator,
                assignedOn: uuidZodValidator,
                completedAt: uuidZodValidator,
                completedDisposition: uuidZodValidator,
                disposition: uuidZodValidator,
                eventContainerId: uuidZodValidator,
                leadCategory: uuidZodValidator,
                planDate: uuidZodValidator,
                queueMode: uuidZodValidator,
                queueReason: uuidZodValidator,
                scheduledOn: uuidZodValidator,
                slaBreachedAt: uuidZodValidator,
                sourcePriority: uuidZodValidator,
                itemStatus: uuidZodValidator,
            }),
        }),
        [AgentViewWorkspaceCapabilityUdoTemplateKey.dayPlanRun]: zod.strictObject({
            udoTemplateId: uuidZodValidator,
            udoAdditionalColumnIds: zod.strictObject({
                completedAt: uuidZodValidator,
                planDate: uuidZodValidator,
            }),
        }),
    }),
}) satisfies zod.ZodType<AgentViewWorkspaceCapabilityUdoBindings>;
